module.exports = __webpack_public_path__ + "img/combined-mockup.c86878df.png";